import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Container } from 'react-bootstrap';

import ModeloCadastro from './ModeloCadastro';

import Button from '../../components/Button';

import ListaModelos from './ListaModelos';
import { useAuth } from '../../hooks/auth';
import { TIPO_USUARIO } from '../../utils/funcoes';

export interface IModelo {
  ModCodigo: number;
  ModNome: string;
  ModTexto: string;
  ModTipo: number;
  ModAtivo: boolean;
  ativoFormatado?: string;
  nomeTipo?: string;
  updated_at: Date;
  dataAtualizacaoFormatada: string;
  usuarioEditor: {
    UsuCodigo: number;
    UsuNome: string;
  };
}

type pageProps = {
  modeloMensagem?: boolean;
};

const Modelo: React.FC<pageProps> = ({ modeloMensagem = false }) => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const [showModalCadastro, setShowModalCadastro] = useState(false);
  const [modeloSelecionado, setModeloSelecionado] = useState<
    IModelo | undefined
  >(undefined);

  return (
    <Container fluid className="mt-2">
      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">
            Modelos de {modeloMensagem ? 'Mensagem' : 'Documentos'}
          </h2>
          {modeloMensagem === false && !showModalCadastro && (
            <div>
              <Button
                type="button"
                variant="success"
                onClick={() => {
                  setModeloSelecionado(undefined);
                  setShowModalCadastro(true);
                }}
              >
                Novo Modelo
              </Button>
            </div>
          )}
          {showModalCadastro && (
            <div>
              <Button
                type="button"
                variant="success"
                onClick={() => {
                  setModeloSelecionado(undefined);
                  setShowModalCadastro(false);
                }}
              >
                Voltar para Lista
              </Button>
            </div>
          )}
        </div>
        <p>
          {modeloMensagem
            ? 'Configure o modelo de texto padrão utilizados nas comunicações com o paciente, como confirmação de agendamentos, aniversário, cobranças'
            : 'Configure o modelo de texto padrão utilizados nos prontuários, receitas e documentos gerados para o paciente.'}
        </p>
      </div>
      <div className="bg-white border p-2">
        {showModalCadastro && (
          <ModeloCadastro
            setShowModal={setShowModalCadastro}
            modelo={modeloSelecionado}
            modeloMensagem={modeloMensagem}
          />
        )}
        {!showModalCadastro && (
          <ListaModelos
            setShowModal={setShowModalCadastro}
            showModal={showModalCadastro}
            setModeloSelecionado={setModeloSelecionado}
            modeloMensagem={modeloMensagem}
          />
        )}
      </div>
    </Container>
  );
};

export default Modelo;
